{
	"type": "fill",
	"minzoom": 7,
	"layout": {},
	"paint": {
		"fill-color": "#79230B",
		"fill-opacity": ["step", ["zoom"], ["case", ["get", "all_zoom_levels"], 1, 0], 11, 0.26]
	}
}
